import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundLayout"] */ "/app/src/app/providers/BackgroundLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Footer/components/Copyright/Desktop/Copyright.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Footer/ui/Desktop/FooterBottom/FooterBottom.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Footer/components/MainFooter/Desktop/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FooterTop"] */ "/app/src/shared/common/Footer/ui/Desktop/FooterTop/FooterTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopHeaderTop"] */ "/app/src/shared/common/Header/components/HeaderTop/Desktop/HeaderTop.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Header/components/MainHeader/Desktop/Header.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/providers/MobileLayout.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Header/ui/HeaderActions/Desktop/HeaderActions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Header/ui/HeaderCatalogButton/Desktop/HeaderCatalog.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/Header/ui/HeaderSearch/Desktop/HeaderSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/src/shared/common/Menubar/components/Menu/Mobile/Menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/divider/Divider.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Image/index.tsx");
